import { Mail, MessageCircle, Phone } from "lucide-react";

import { CallLink } from "../calls/CallTracker";
import { useCompanyBlock } from "../companies/ContactBlock";
import type { Contact } from "../types";
import { isWhatsAppCapable } from "../misc/phone";

// LDF: Große Tipp-Flächen fürs Handy – Anrufen (mit Nachhalten), WhatsApp und E-Mail direkt unter dem Namen.

const whatsappHref = (number: string) => {
  let digits = number.replace(/\(0\)/g, "").replace(/[^\d+]/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  else if (digits.startsWith("+")) digits = digits.slice(1);
  else if (digits.startsWith("0")) digits = `49${digits.slice(1)}`;
  return `https://wa.me/${digits}`;
};

const isMobileNumber = isWhatsAppCapable;

export const ContactQuickActions = ({ record }: { record: Contact }) => {
  const blocked = !!useCompanyBlock(record.company_id);
  const phones = (record.phone_jsonb ?? []).filter((p) => p?.number);
  const emails = (record.email_jsonb ?? []).filter((e) => e?.email);
  const name = [record.first_name, record.last_name].filter(Boolean).join(" ");

  if (blocked) return <p className="rounded-md bg-muted px-3 py-2 text-sm text-muted-foreground">Kontaktsperre – nicht kontaktieren.</p>;
  if (!phones.length && !emails.length) return null;

  const tile = "flex min-h-12 items-center gap-2 rounded-xl border border-border bg-card px-3 py-2 text-sm no-underline active:bg-muted";
  return (
    <div className="grid gap-2">
      {phones.map((p) => (
        <div key={p.number} className="flex gap-2">
          <CallLink number={p.number} name={name} contactId={record.id} companyId={record.company_id} className={`${tile} flex-1`}>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground">
              <Phone className="h-4 w-4" />
            </span>
            <span className="min-w-0">
              <span className="block font-medium">Anrufen</span>
              <span className="block truncate text-xs text-muted-foreground">{p.number}</span>
            </span>
          </CallLink>
          {isMobileNumber(p.number) && (
            <a href={whatsappHref(p.number)} target="_blank" rel="noopener noreferrer" className={tile} aria-label={`WhatsApp an ${p.number}`}>
              <MessageCircle className="h-5 w-5 text-green-600" />
            </a>
          )}
        </div>
      ))}
      {emails.map((e) => (
        <a key={e.email} href={`mailto:${e.email}`} className={tile}>
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary text-secondary-foreground">
            <Mail className="h-4 w-4" />
          </span>
          <span className="min-w-0">
            <span className="block font-medium">E-Mail</span>
            <span className="block truncate text-xs text-muted-foreground">{e.email}</span>
          </span>
        </a>
      ))}
    </div>
  );
};
